var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar sidebar-right pt-3"},[_c('Prize'),_c('div',{staticClass:"px-4"},[_c('Heist')],1),_c('div',{staticClass:"px-4"},[_c('Lottery')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }